import { useContext } from 'react';

import { OmeMeetOrgUnitContactStateContext } from './OmeMeetOrgUnitContactContextProvider';

import OmeMeetOrgUnitContactData from './OmeMeetOrgUnitContactData';

const useOmeMeetOrgUnitContactData = () => {
  const [omeMeetOrgUnitContactState, setOmeMeetOrgUnitContactState] = useContext(OmeMeetOrgUnitContactStateContext);

  const getOmeMeetOrgUnitContacts = (omeMeetId, orgUnitId) => {
    OmeMeetOrgUnitContactData.getOmeMeetOrgUnitContactsData(omeMeetId, orgUnitId, omeMeetOrgUnitContactState, setOmeMeetOrgUnitContactState);
  };

  const postOmeMeetOrgUnitContact = (omeMeetOrgUnitContactObj) => {
    OmeMeetOrgUnitContactData.postOmeMeetOrgUnitContactData(omeMeetOrgUnitContactObj, omeMeetOrgUnitContactState, setOmeMeetOrgUnitContactState);
  };

  const putOmeMeetOrgUnitContact = (omeMeetOrgUnitContactId, omeMeetOrgUnitContactObj) => {
    OmeMeetOrgUnitContactData.putOmeMeetOrgUnitContactData(omeMeetOrgUnitContactId, omeMeetOrgUnitContactObj, omeMeetOrgUnitContactState, setOmeMeetOrgUnitContactState);
  };

  const deleteOmeMeetOrgUnitContact = (omeMeetOrgUnitContactId) => {
    OmeMeetOrgUnitContactData.deleteOmeMeetOrgUnitContactData(omeMeetOrgUnitContactId, omeMeetOrgUnitContactState, setOmeMeetOrgUnitContactState);
  };

  const confirmSaveOmeMeetOrgUnitContact = () => {
    setOmeMeetOrgUnitContactState({
      ...omeMeetOrgUnitContactState,
      isSaved: false
    });
  };

  const resetOmeMeetOrgUnitContactState = () => {
    setOmeMeetOrgUnitContactState(OmeMeetOrgUnitContactData.INITIAL_STATE);
  }

  return {
    omeMeetOrgUnitContactState,
    setOmeMeetOrgUnitContactState,
    getOmeMeetOrgUnitContacts,
    postOmeMeetOrgUnitContact,
    putOmeMeetOrgUnitContact,
    deleteOmeMeetOrgUnitContact,
    confirmSaveOmeMeetOrgUnitContact,
    resetOmeMeetOrgUnitContactState
  };
};

export default useOmeMeetOrgUnitContactData;